import { EntityRepository, Repository } from "typeorm";
import { VariantOperation } from "../variant-operation.entity";

@EntityRepository(VariantOperation)
export class VariantOperationRepository extends Repository<VariantOperation> {
    
}